import { useState } from "react";
import { Egypt, Tick } from "../../Icons";
import style from "./Inputs.module.css";
import { useTranslation } from "../../../hooks/useTranslation";

const InputField = ({
  label,
  type,
  placeholder,
  extraProps,
  isSecondary,
  note,
  isRequired = false,
  error,
  isSwitch = false,
}: componentProps) => {
  const { locale } = useTranslation();

  const [passowrdIsVisible, setPassowrdIsVisible] = useState<boolean>(false);

  return (
    <div
      className={`${style.input_container}${
        type === "checkbox" ? ` ${isSwitch ? style.input_switch : style.input_checkbox}` : ""
      }`}
    >
      {label && type !== "checkbox" && (
        <label>
          {label}
          {!!isRequired && <span className={style.reqFeild}>*</span>}
        </label>
      )}
      {type === "textarea" ? (
        <textarea
          className={`${style.input}${isSecondary ? ` ${style["input--secondary"]}` : ""}`}
          placeholder={placeholder}
          autoComplete="true"
          {...extraProps}
        ></textarea>
      ) : (
        <input
          className={`${style.input}${isSecondary ? ` ${style["input--secondary"]}` : ""}${
            type === "phone" ? ` ${style.input_phone}` : ""
          }`}
          type={type === "password" ? (passowrdIsVisible ? "text" : "password") : type === "phone" ? "tel" : type}
          placeholder={placeholder}
          autoComplete="true"
          {...extraProps}
          {...(extraProps?.name ? { id: extraProps.name } : {})}
        />
      )}
      {note && <span className={style.input_note}>{note}</span>}
      {error && (
        <span className={style.input_note} style={{ color: "#dc0000" }}>
          {error}
        </span>
      )}
      {type === "phone" && (
        <p className={style.phone_number}>
          <Egypt width="15" height="15" color="#000" />
          +20
        </p>
      )}
      {type === "password" && (
        <button
          type="button"
          className={style.password_visible}
          onClick={() => setPassowrdIsVisible((current) => !current)}
        >
          {locale(passowrdIsVisible ? "hide" : "show")}
        </button>
      )}
      {type === "checkbox" && (
        <>
          <div className={style.checkbox_memic}>
            {isSwitch ? <div></div> : <Tick width="10" height="10" color="#fff" />}
          </div>
          {label && <label {...(extraProps?.name ? { htmlFor: extraProps.name } : {})}>{label}</label>}
        </>
      )}
    </div>
  );
};

export default InputField;

type componentProps = {
  type: string;
  label?: string;
  placeholder?: string;
  extraProps?: any;
  isSecondary?: boolean;
  note?: string;
  isRequired?: boolean;
  error?: any;
  isSwitch?: boolean;
};
